import React from 'react';
import { Trash } from "react-bootstrap-icons";
import { BoothsWithLiveRecruiterCount } from 'app/API';


interface BoothCardProps {
    booth: BoothsWithLiveRecruiterCount;
    recruiterNames: Map<number, string>;
    index: number;
    handleEdit: (booth: BoothsWithLiveRecruiterCount) => void;
    handleDelete: (booth: BoothsWithLiveRecruiterCount) => void;
    showDeleteIcon: boolean;
    companyImageUrl?: string;
}

const AdminBoothCard: React.FC<BoothCardProps> = ({ booth, recruiterNames, index, handleEdit, handleDelete, showDeleteIcon, companyImageUrl }) => {
    return (
        <div key={booth.id}>
            <div className='card border border-2 border-gray-300 border h-100'>
                <div className='card-header border-0 pt-9 ribbon ribbon-end ribbon-clip'>
                    <div className='card-title'>
                        <img style={{ maxWidth: '150px' }} src={companyImageUrl} alt={booth.name} crossOrigin="anonymous" />
                    </div>
                    {booth.isFeatured &&
                        <div className={`ribbon-label`}>
                            Featured
                            <span className="ribbon-inner bg-success"></span>
                        </div>
                    }
                </div>
                <div className='card-body p-5'>
                    <div className='fs-3 fw-bold text-dark'>{booth.name}</div>
                    <p className='text-gray-400 fw-semibold mt-2'>{booth.description}</p>
                    <div className='d-flex flex-stack mt-3'>
                        <div className='text-gray-700'>Default Interview Duration:</div>
                        <div className='fw-bold'>{booth.chatDuration} minutes</div>
                    </div>
                    <div className='d-flex flex-stack mt-3'>
                        <div className='text-gray-700'>Minimum Score:</div>
                        <div className='fw-bold'>{booth.minimumScore}</div>
                    </div>
                    <div className='mt-3 text-gray-700'>Recruiters</div>
                    <div style={{ border: '1px dashed grey', margin: '5px', minHeight: '50px' }}>
                        {booth.recruiters?.length === 0 ? (
                            <div className='h-100 d-flex align-items-center justify-content-center' title='Drag & drop from Unassigned Recruiters'>
                                <p className='text-center text-muted'>No recruiters assigned. </p></div>
                        ) : (
                            <>{booth.recruiters?.map((recruiter, idx) => (
                                <div key={`recruiter-${recruiter}`} className="d-flex p-1 m-1 justify-content-between align-items-center border">
                                    {recruiterNames.get(recruiter!) || 'Recruiter ' + idx + 1}
                                </div>
                            ))}</>)}
                    </div>
                </div>
                <div className='card-footer d-flex justify-content-between py-3'>
                    <button
                        className='btn btn-primary'
                        onClick={() => handleEdit(booth)}
                    >
                        Manage Booth
                    </button>
                    {showDeleteIcon && <a href="#" className="btn btn-link text-danger" role="button" onClick={() => handleDelete(booth)}>
                        <Trash></Trash>
                    </a>}
                </div>
            </div>
        </div>
    );
};

export default AdminBoothCard;
